import styled from 'styled-components';
import { Colors } from '../../shared/colors/colors';

// export const ModalContainer = styled.div<{ show: boolean }>`
//   display: ${({ show }) => (show ? 'flex' : 'none')};
//   justify-content: center;
//   align-items: center; /* Centraliza */
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0, 0, 0, 0.5);
//   z-index: 1000;
//   animation: slideDown 0.3s ease;
//   overflow-y: auto; /* Rolagem no container */
//   padding: 2rem;
//   box-sizing: border-box;

//   @keyframes slideDown {
//     from {
//       transform: translateY(-100%);
//     }
//     to {
//       transform: translateY(0);
//     }
//   }
// `;

// export const ModalContent = styled.div`
//   background-color: ${Colors.white};
//   border-radius: 4px;
//   display: flex;
//   flex-direction: column;
//   padding: 64px;
//   gap: 16px;
//   position: relative;
//   box-sizing: border-box;
//   /* padding-bottom: 64px; */
// `;

// export const CloseButtonWrapper = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   position: absolute;
//   top: 32px;
//   right: 32px;
// `;

// export const ModalBody = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
//   padding: 32px;
//   background-color: ${Colors.backgroundColorModalBody};
//   border: 1px solid ${Colors.borderColorModalBody};
//   border-radius: 4px;
//   flex-grow: 1; /* Permite que o conteúdo se expanda para o restante da altura */
//   width: 100%; /* Garante que o ModalBody ocupe toda a largura disponível */
//   margin: 24px;
// `;

// export const ModalHeader = styled.div`
//   display: flex;
//   align-items: center;

//   h1 {
//     margin: 0;
//     font-size: 1.5rem;
//   }
// `;

export const ContribuinteName = styled.strong`
  display: inline;
  background-color: #f2f2f2;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 4px;
`;

export const ModalForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
